var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-4"},[_c('support-navigation',{attrs:{"title":"support.chat.create.title","items":_vm.chatTypes},on:{"input":_vm.handleNewChat}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }